import {
    ChevronRight,
} from "lucide-react";
import RecommendationProductCard from "../RecommendationProductCard";
import {
    RecommendationProduct,
} from "../RecommendationProductsData";
import "./CustomersAlsoBoughtSection.css";

type CustomersAlsoBoughtSectionProps = {
    category?: string;
    products?: any[];
};

const CustomersAlsoBoughtSection = ({
    category,
    products: dynamicProducts,
}: CustomersAlsoBoughtSectionProps) => {
    if (!dynamicProducts || dynamicProducts.length === 0) {
        return null;
    }

    const products: RecommendationProduct[] = dynamicProducts.map((p: any) => ({
        id: p._id || p.ssin,
        badge: p.featuredOffer?.deal?.dealName || "POPULAR",
        title: p.name || "-",
        description: p.description || "-",
        image: p.mainImage || "",
        colors: [],
        extraColors: 0,
        rating: Number(p.reviews?.averageRating ?? 0),
        reviews: p.reviews?.totalReviews ? String(p.reviews.totalReviews) : "0",
        deal: p.featuredOffer?.deal?.dealName || "-",
        dealType: "special",
        price: Number(p.featuredOffer?.finalPrice ?? p.featuredOffer?.unitPrice ?? 0),
        mrp: Number(p.featuredOffer?.mrp ?? p.featuredOffer?.finalPrice ?? 0),
        delivery: p.featuredOffer?.delivery?.freeDelivery ? "Free Delivery" : "-",
        deliveryType: "delivery",
        category: p.categoryHierarchy?.superCategory || category || "-",
    }));

    if (products.length === 0) {
        return null;
    }

    return (
        <section className="also-bought">
            <div className="also-bought-container">
                <div className="also-bought-header">
                    <div>
                        <span>
                            BOUGHT TOGETHER
                        </span>

                        <h2>
                            Popular picks from similar shoppers
                        </h2>

                        <p>
                            Products frequently explored and purchased by customers interested in this item.
                        </p>
                    </div>

                    <button type="button">
                        See collection

                        <ChevronRight
                            size={16}
                        />
                    </button>
                </div>

                <div className="also-bought-grid">
                    {products.map(
                        (
                            product
                        ) => (
                            <RecommendationProductCard
                                key={
                                    product.id
                                }
                                product={
                                    product
                                }
                            />
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default CustomersAlsoBoughtSection;